var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserQuestionmark28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4286 7.99999C23.4286 10.5247 21.3819 12.5714 18.8571 12.5714C16.3324 12.5714 14.2857 10.5247 14.2857 7.99999C14.2857 5.47526 16.3324 3.42856 18.8571 3.42856C21.3819 3.42856 23.4286 5.47526 23.4286 7.99999Z",
    fill: "url(#paint0_linear_12038_10610)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 24.2891C7.99998 21.1339 9.71031 18.2265 12.4682 16.6937L12.9781 16.4103C13.2955 16.234 13.4544 16.1456 13.606 16.0672C16.8995 14.3635 20.8148 14.3635 24.1082 16.0672C24.2599 16.1456 24.4186 16.2339 24.7361 16.4103L25.246 16.6937C28.0039 18.2265 29.7143 21.1339 29.7143 24.2891C29.7143 25.8163 28.6529 27.1324 27.1426 27.3594C25.1388 27.6607 22.1506 28 18.8571 28C15.5637 28 12.5755 27.6607 10.5716 27.3594C9.06139 27.1324 7.99998 25.8163 7.99998 24.2891Z",
    fill: "url(#paint1_linear_12038_10610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69713 13.6682C5.86856 13.8625 6.10284 13.9596 6.39999 13.9596C6.6857 13.9596 6.90284 13.9025 7.05141 13.7882C7.19999 13.6625 7.29713 13.5082 7.34284 13.3253C7.38856 13.1082 7.45141 12.9082 7.53141 12.7253C7.62284 12.5425 7.7657 12.3539 7.95999 12.1596C8.15427 11.9539 8.42856 11.7196 8.78284 11.4567C9.19427 11.1596 9.51427 10.8682 9.74284 10.5825C9.97141 10.2853 10.1371 9.98246 10.24 9.67389C10.3428 9.36532 10.3943 9.0396 10.3943 8.69675C10.3943 8.09103 10.2286 7.56532 9.89713 7.1196C9.5657 6.66246 9.09713 6.30818 8.49141 6.05675C7.89713 5.80532 7.2057 5.6796 6.41713 5.6796C5.95999 5.6796 5.46856 5.73675 4.94284 5.85103C4.41713 5.95389 3.91999 6.1196 3.45141 6.34818C3.09713 6.5196 2.83427 6.73675 2.66284 6.9996C2.50284 7.26246 2.42856 7.53103 2.43999 7.80532C2.46284 8.0796 2.54856 8.3196 2.69713 8.52532C2.8457 8.73103 3.05141 8.86818 3.31427 8.93675C3.57713 8.99389 3.87999 8.93103 4.22284 8.74818C4.51999 8.58818 4.82856 8.46818 5.14856 8.38818C5.46856 8.30818 5.81141 8.26818 6.17713 8.26818C6.54284 8.26818 6.82284 8.33675 7.01713 8.47389C7.21141 8.61103 7.30856 8.81103 7.30856 9.07389C7.30856 9.21103 7.2857 9.34818 7.23999 9.48532C7.19427 9.61103 7.11427 9.74818 6.99999 9.89675C6.89713 10.0453 6.75427 10.2167 6.57141 10.411C6.29713 10.6853 6.07427 10.9596 5.90284 11.2339C5.74284 11.4967 5.62284 11.7653 5.54284 12.0396C5.47427 12.3025 5.43999 12.5882 5.43999 12.8967C5.43999 13.2167 5.5257 13.4739 5.69713 13.6682Z",
    fill: "url(#paint2_linear_12038_10610)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09713 17.5939C5.4057 17.9025 5.82284 18.0567 6.34856 18.0567C6.87427 18.0567 7.2857 17.9025 7.58284 17.5939C7.87999 17.2853 8.02856 16.8796 8.02856 16.3767C8.02856 15.8853 7.87999 15.491 7.58284 15.1939C7.2857 14.8853 6.87427 14.731 6.34856 14.731C5.82284 14.731 5.4057 14.8853 5.09713 15.1939C4.79999 15.491 4.65141 15.8853 4.65141 16.3767C4.65141 16.8796 4.79999 17.2853 5.09713 17.5939Z",
    fill: "url(#paint3_linear_12038_10610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_10610",
    x1: 2.43884,
    y1: 3.42856,
    x2: 26.877,
    y2: 30.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12038_10610",
    x1: 2.43884,
    y1: 3.42856,
    x2: 26.877,
    y2: 30.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12038_10610",
    x1: 2.43884,
    y1: 3.42856,
    x2: 26.877,
    y2: 30.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12038_10610",
    x1: 2.43884,
    y1: 3.42856,
    x2: 26.877,
    y2: 30.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQuestionmark28);
export default __webpack_public_path__ + "static/media/user_questionmark_28.34bff148.svg";
export { ForwardRef as ReactComponent };